import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './WebChatSync.css';
// TingLogoVector removed from the import while the logo below is hidden
import { IconSyncLock } from '../../Components/Common/Icons';

const WebChatSyncUI = ({ isSyncing, isSyncComplete, progress = 0 }) => {
    const [shouldShow, setShouldShow] = useState(true);
    const [isHiding, setIsHiding] = useState(false);

    useEffect(() => {
        if (isSyncComplete && progress >= 100) {
            // Show 100% for 500ms before starting fade out
            const hideTimer = setTimeout(() => {
                setIsHiding(true);
                // Actually remove from DOM after fade animation completes
                const removeTimer = setTimeout(() => {
                    setShouldShow(false);
                }, 300); // Match CSS transition duration
                return () => clearTimeout(removeTimer);
            }, 500);

            return () => clearTimeout(hideTimer);
        }
    }, [isSyncComplete, progress]);

    // Don't render anything if sync is complete and hide animation finished
    if (!shouldShow) {
        return null;
    }

    return (
        <div
            className={`sync-status-progress ${isSyncing || progress === 100 ? 'syncing' : 'complete'} ${isHiding ? 'hiding' : ''}`}
        >
            {(isSyncing || progress === 100) && (
                <div className="progress_bartop">
                    <div className="progress_contain">
                        {/* Temporarily hidden: Dazway wordmark logo on the sync loading screen */}
                        {/* <img src={TingLogoVector} alt="logo" /> */}
                        <div className="progress-bar">
                            <div className="prog-status" style={{ width: `${Math.min(progress, 100)}%` }}></div>
                        </div>
                        <p>
                            <IconSyncLock className="load_lock" />
                            End-to-end encrypted
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

const WebChatSync = () => {
    const syncProgress = useSelector(state => state.syncProgressData?.progress || 0);

    // Use progress to determine sync status
    const isSyncComplete = syncProgress >= 100;
    const isSyncing = syncProgress >= 0 && syncProgress < 100;

    // Always render WebChatSyncUI, it will handle visibility internally
    return <WebChatSyncUI isSyncing={isSyncing} isSyncComplete={isSyncComplete} progress={syncProgress} />;
};

export { WebChatSyncUI };
export default WebChatSync;
